import bear1 from "./avatars/bear-1.png";
import bee1 from "./avatars/bee-1.png";
import boy1 from "./avatars/boy-1.png";
import chicken1 from "./avatars/chicken-1.png";
import cow1 from "./avatars/cow-1.png";
import cow2 from "./avatars/cow-2.png";
import cow3 from "./avatars/cow-3.png";
import dog1 from "./avatars/dog-1.png";
import dog2 from "./avatars/dog-2.png";
import elephant1 from "./avatars/elephant-1.png";
import elephant2 from "./avatars/elephant-2.png";
import ghost1 from "./avatars/ghost-1.png";
import girl1 from "./avatars/girl-1.png";
import lamb1 from "./avatars/lamb-1.png";
import lion1 from "./avatars/lion-1.png";
import lion2 from "./avatars/lion-2.png";
import monkey1 from "./avatars/monkey-1.png";
import monkey2 from "./avatars/monkey-2.png";
import monkey3 from "./avatars/monkey-3.png";
import monkey4 from "./avatars/monkey-4.png";
import monkey5 from "./avatars/monkey-5.png";
import monkey6 from "./avatars/monkey-6.png";
import monkey7 from "./avatars/monkey-7.png";
import monkey8 from "./avatars/monkey-8.png";
import monkey9 from "./avatars/monkey-9.png";
import monkey10 from "./avatars/monkey-10.png";
import monkey11 from "./avatars/monkey-11.png";
import orange1 from "./avatars/orange-1.png";
import owl1 from "./avatars/owl-1.png";
import owl2 from "./avatars/owl-2.png";
import octopus1 from "./avatars/octopus-1.png";
import panda1 from "./avatars/panda-1.png";
import panda2 from "./avatars/panda-2.png";
import penguin1 from "./avatars/penguin-1.png";
import penguin2 from "./avatars/penguin-2.png";
import penguin3 from "./avatars/penguin-3.png";
import penguin4 from "./avatars/penguin-4.png";
import penguin5 from "./avatars/penguin-5.png";
import penguin6 from "./avatars/penguin-6.png";
import seal1 from "./avatars/seal-1.png";
import seal2 from "./avatars/seal-1.png";
import sun1 from "./avatars/sun-1.png";
import tiger1 from "./avatars/tiger-1.png";
import turkey1 from "./avatars/turkey-1.png";
import turtle1 from "./avatars/turtle-1.png";

const avatars = {
  bear1, 
  bee1, 
  boy1, 
  chicken1, 
  cow1, 
  cow2,
  cow3,
  dog1,
  dog2,
  elephant1,
  elephant2,
  ghost1,
  girl1,
  lamb1,
  lion1,
  lion2,
  monkey1,
  monkey2,
  monkey3,
  monkey4,
  monkey5,
  monkey6,
  monkey7,
  monkey8,
  monkey9,
  monkey10,
  monkey11,
  orange1,
  owl1,
  owl2,
  octopus1,
  panda1,
  panda2,
  penguin1,
  penguin2,
  penguin3,
  penguin4,
  penguin5,
  penguin6,
  seal1,
  seal2,
  sun1,
  tiger1,
  turkey1,
  turtle1
}
export const avatarIds = Object.keys(avatars);

export default avatars;


     